import { createFormContext } from '@mantine/form'

export interface RegisterFormData {
  email: string
  password: string
  confirmPassword: string
}

export const [RegisterFormProvider, useRegisterFormContext, useRegisterForm] = createFormContext<RegisterFormData>()